<template>
  <!-- Modal tapu -->
  <div
    class="modal fade"
    id="proxy-service-modal"
    ref="ProxyServiceModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="proxy-service-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="proxy-service-modal">{{ $t('Vekalet Hizmetini Neden Almalıyım?') }}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <div class="video-container">
            <iframe
              class="full-width"
              :src="vid"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">{{ $t('Kapat') }}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'ProxyServiceModal',
  data() {
    return {
      vid: 'https://www.youtube.com/embed/bxnQ6fKj6Sg?si=Xh4fdtZZJEvP2RbG',
    };
  },
  methods: {
    setVideo() {
      this.vid = 'https://www.youtube.com/embed/bxnQ6fKj6Sg?si=Xh4fdtZZJEvP2RbG';
    },
    closeVideo() {
      this.vid = '';
    },
  },
  mounted() {
    $(this.$refs.ProxyServiceModal).on('hidden.bs.modal', this.closeVideo);
    $(this.$refs.ProxyServiceModal).on('shown.bs.modal', this.setVideo);
  },
};
</script>

<style lang="less" scoped>
.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 oranı */
  height: 0;
  overflow: hidden;
  max-width: 100%; /* Kapsayıcı genişliğiyle uyumlu */
  background: black; /* Siyah arkaplan ekleyebilirsiniz */
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
